import React, { useState } from "react";
import DataTable from "react-data-table-component";
import DatatableStyles from "component/utils/DatatableStyles";

const paginationOptions = {
  rowsPerPageText: "Show Per Page:",
  rangeSeparatorText: "dari",
};

const RoomDatatables = ({ data = [], onEditRoom, onDeleteRoom }) => {
  const [search, setSearch] = useState("");

  // Tambah nomor urut
  const formattedData = data.map((item, index) => ({
    no: index + 1,
    ...item,
  }));

  // Search berdasarkan nomor kamar & tipe kamar
  const filteredData = formattedData.filter((item) =>
    [item.room_number, item.item_title]
      .some((field) =>
        field?.toString().toLowerCase().includes(search.toLowerCase())
      )
  );

  const columns = [
    {
      name: "No",
      selector: (row) => row.no,
      width: "70px",
      center: true,
      sortable: true,
    },
    {
      name: "Nomor Kamar",
      selector: (row) => row.room_number,
      sortable: true,
    },
    {
      name: "Tipe Kamar",
      selector: (row) => row.item_title,
      sortable: true,
      grow: 2,
    },
    {
      name: "Lantai",
      selector: (row) => row.floor,
      center: true,
      sortable: true,
    },
    {
      name: "Status",
      center: true,
      cell: (row) => (
        <span
          className={`badge ${
            row.status === "AVAILABLE" ? "bg-success" : "bg-secondary"
          }`}
        >
          {row.status}
        </span>
      ),
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <div>
          <button
            className="btn btn-sm rounded-circle btn-warning me-2"
            onClick={() => onEditRoom(row)}
          >
            <i className="bx bx-edit" style={{ color: "white" }}></i>
          </button>

          <button
            className="btn btn-sm rounded-circle btn-danger"
            onClick={() => onDeleteRoom(row)}
          >
            <i className="bx bx-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="col-lg-12 mb-4">
      <div className="d-flex justify-content-start align-items-center mb-2">
        <input
          type="text"
          placeholder="Search room / type..."
          className="form-control"
          style={{ maxWidth: "250px" }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="datatable-container">
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          customStyles={DatatableStyles}
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 25]}
          paginationComponentOptions={paginationOptions}
          responsive
        />
      </div>
    </div>
  );
};

export default RoomDatatables;
